export const LANDING_PATH = '/';

export const LOGIN_PATH = '/login';
export const EDIT_PATH = '/editProfile';
export const HOME_PATH = '/home';

export const USER_PAST_INTERVIEWS_PATH = '/pastsInterviews';
export const USER_INCOMING_INTERVIEWS_PATH = '/incomingInterviews';

export const WEE_MOCK_PATH = '/scheduleInterview';

export const WER_MATCH_PATH = '/matchInterviews';

export const FEEDBACK_HELPER_PATH = '/feedbackHelper';
export const WEE_DETAIL_PATH = '/intervieweeDetails'; // ?
